import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreSalesTaxModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { DeleteSalesTaxModalComponent } from './delete-sales-tax-modal.component';

@NgModule({
  imports: [CommonModule, DatastoreSalesTaxModule, UiModule, TrackingModule],
  declarations: [DeleteSalesTaxModalComponent],
})
export class DeleteSalesTaxModalModule {}
